import { wrap } from 'comlink';
import { flatMapDeep, fromPairs } from 'lodash';
import axios from 'axios';
import { registerPixels } from './pixels';
import mailcheck from 'mailcheck';

const SooperPanelPropsKeys = [
    'cake-id',
    'visit-id',
    'user-id',
    'funnel-id',
    'referrer',
    'browser-id',
    'entries',
    'log-events',
    'keep-pop',
    'template-id',
    'offers',
    'source',
    'anuranum',
    'anuraper',
    'criteo-id',
    'criteo-bucket-limit',
    'theme',
  ],
  DOMAINS = [
    'aim.com',
    'aol.com',
    'att.net',
    'comcast.net',
    'bellsouth.net',
    'charter.net',
    'comcast.net',
    'cox.net',
    'earthlink.net',
    'facebook.com',
    'gmail.com',
    'googlemail.com',
    'google.com',
    'hotmail.com',
    'icloud.com',
    'juno.com',
    'live.com',
    'mac.com',
    'me.com',
    'mail.com',
    'msn.com',
    'optonline.net',
    'outlook.com',
    'pobox.com',
    'rocketmail.com',
    'sbcglobal.net',
    'verizon.net',
    'yahoo.com',
    'ymail.com',
    'mdm.com',
    'mdm0.com',
    'mdm5.com',
  ],
  TOP_LEVEL_DOMAINS = ['com', 'net', 'org'];

const handleSuggestedEmail = (panel, { full, previous }) => {
  const elem = document.createElement('div'),
    isMobile = /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
      navigator.userAgent,
    );

  if (panel.elem.querySelector('#suggestion')) {
    panel.elem.querySelector('#suggestion').remove();
    elem.classList.add('shake', 'animated');
  }

  elem.id = 'suggestion';
  elem.style.textAlign = 'center';
  elem.style.margin = '20px auto';

  elem.innerHTML = `
    <p style="margin: 8px; color: #272525;">Did you mean <strong style="color: #490b62">${full}</strong></p>
    <div style="display: flex; justify-content: space-evenly; margin: auto; max-width: ${
      isMobile ? 50 : 30
    }%;">
      <div>
        <input style="margin: 0" id="suggest-yes" name="suggestion_confirm" type="radio" value="yes" />
        <label style="color: #272525;" for="suggest-yes">Yes</label>
      </div>
      <div>
        <input style="margin: 0" id="suggest-no" name="suggestion_confirm" type="radio" value="no" />
        <label style="color: #272525;" for="suggest-no">No</label>
      </div>
    </div>
  `;

  Array.from(elem.querySelectorAll('input')).forEach((inpt) => {
    inpt.addEventListener('change', (e) => {
      switch (e.target.value) {
        case 'no':
          panel.field.setAttribute('email-bypass', true);
          break;
        case 'yes':
          panel.field.value = full;
          break;
      }
      window.sooper_panel.controller.continueBtn.click();
    });
  });

  // if (window.sooper_panel.props.user_id !== '901051xgIp') {
  //   return true;
  // }

  panel.elem.append(elem);
  return false;
};

export const validateEmailAddress = (email_address) => {
  const panel = window.sooper_panel.controller.active;

  if (panel.field.hasAttribute('email-bypass')) {
    return true;
  }

  return mailcheck.run({
    email: email_address,
    domains: DOMAINS,
    topLevelDomains: TOP_LEVEL_DOMAINS,
    suggested: (suggestion) => {
      return handleSuggestedEmail(
        panel,
        Object.assign(suggestion, { previous: email_address }),
      );
    },
    empty: () => {
      return true;
    },
  });
};

export const scrollToPartners = () => {
  setTimeout(() => {
    document.getElementById('modal-partners').scrollIntoView({
      behavior: 'auto',
      block: 'center',
      inline: 'center',
    });
  }, 100);
};

export const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);

  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const getDocumentHeight = () => {
  return Math.max(
    window.document.body.scrollHeight,
    window.document.body.offsetHeight,
    window.document.documentElement.clientHeight,
    window.document.documentElement.scrollHeight,
    window.document.documentElement.offsetHeight,
  );
};

const anuraGetPixels = (props) => {
  if ((window.sooper_panel.props.cake_id || false) === false) {
    return;
  }

  var xmlRequest = new XMLHttpRequest();
  xmlRequest.open('POST', '/api/sooper/flow/pixels');
  xmlRequest.setRequestHeader('Content-Type', 'application/json');
  xmlRequest.onload = function () {
    if (xmlRequest.status === 200) {
      var response = JSON.parse(xmlRequest.response);
      registerPixels(response.payload.pixels);
    }
  };
  xmlRequest.send(
    JSON.stringify(
      Object.assign(
        {
          cake_id: window.sooper_panel.props.cake_id,
          funnel_id: window.sooper_panel.props.funnel_id,
          email_address: window.sooper_panel.props.profile.email_address,
          source: window.sooper_panel.props.source || null,
        },
        props,
      ),
    ),
  );
};

const sendToMeme = () => {
  return setTimeout(function () {
    try {
      return (window.location.href = '/bad.php' + window.location.search);
    } catch (e) {
      return sendToMeme(timeout + 500);
    }
  });
};

const anuraSaveBad = (props, cb) => {
  var xmlRequest = new XMLHttpRequest();
  xmlRequest.open('POST', '/api/sooper/flow/anura');
  xmlRequest.setRequestHeader('Content-Type', 'application/json');
  xmlRequest.onload = function () {
    return cb();
  };
  xmlRequest.send(
    JSON.stringify(
      Object.assign(
        {
          funnel_id: window.sooper_panel.props.funnel_id,
          email_address: window.sooper_panel.props.profile.email_address,
          source: window.sooper_panel.props.source || null,
        },
        props,
      ),
    ),
  );
};

export const anuraCallback = () => {
  let emailAddress = window.sooper_panel.props.profile.email_address,
    xmlRequest = new XMLHttpRequest(),
    props = [
      `exid=${window.sooper_panel.props.visit_id}`,
      'instance=3907264896',
    ];

  if (emailAddress.toLowerCase().indexOf('@mdm5.com') !== -1) {
    return anuraGetPixels({
      status: -1,
      response: '@mdm5.com',
    });
  }

  xmlRequest.open('POST', 'https://script.anura.io/result.json');
  xmlRequest.setRequestHeader(
    'Content-Type',
    'application/x-www-form-urlencoded',
  );
  xmlRequest.onload = () => {
    if (xmlRequest.status !== 200) {
      return anuraGetPixels({
        status: xmlRequest.status,
        response: 'HTTPRequest Returned Invalid Status',
      });
    }

    var response = JSON.parse(xmlRequest.response);
    document
      .querySelector('html')
      .setAttribute('anura-result', response.result);

    switch (response.result) {
      case 'bad':
        window.sooper_panel.wrapper.querySelector(
          'button[id="continue"]',
        ).disabled = true;
        return anuraSaveBad(
          {
            status: xmlRequest.status,
            response: response.result,
          },
          sendToMeme,
        );
      default:
        return anuraGetPixels({
          status: xmlRequest.status,
          response: response.result,
        });
    }
  };
  xmlRequest.send(props.join('&'));
};

export const initAnura = (visitId, anuranum, anuraper) => {
  // 20%
  if (anuranum > anuraper) {
    // if (Math.random() * 100 > 10) {
    return;
  }

  const anura = document.createElement('script'),
    scripts = document.getElementsByTagName('script')[0],
    source = getUrlParameter('utm_source') || 'FMDEF',
    campaign = getUrlParameter('utm_campaign') || '';

  if (typeof anura !== 'object') {
    return;
  }

  let additional = JSON.stringify({ 1: visitId });

  anura.type = 'text/javascript';
  anura.async = true;
  anura.src =
    `https://script.anura.io/request.js?instance=3907264896&callback=sooper_panel.anuraCallback&additional=${additional}&source=${source}&campaign=${campaign}&exid=${visitId}&` +
    Date.now();
  scripts.parentNode.insertBefore(anura, scripts);
};

const isValidVisitId = (visitId) => {
  return typeof visitId === 'string' && visitId !== '' && visitId.length === 10;
};

export const addTrustedForm = function () {
  const visitId = window.sooper_panel.props.visit_id;

  let field = escape('xxTrustedFormCertUrl'),
    identifier = isValidVisitId(visitId) ? `&identifier=${visitId}` : '',
    provideReferrer = escape(false),
    invertFieldSensitivity = false,
    tf = document.createElement('script'),
    protocol = 'http' + (document.location.protocol ? 's' : ''),
    l = new Date().getTime() + Math.random();

  tf.type = 'text/javascript';
  tf.async = true;
  tf.src = `${protocol}://api.trustedform.com/trustedform.js?provide_referrer=${provideReferrer}&field=${field}${identifier}&l=${l}&invert_field_sensitivity=${invertFieldSensitivity}`;
  let s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(tf, s);
};

const getMarketingPartners = function () {
  $.getJSON('/versions/680/assets/list.json', function (data) {
    if (!data.hasOwnProperty('data')) return;

    var urls = {},
      urlArr = data.url,
      elem = document.getElementById('modal-partners'),
      partners = data.data.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });

    if (elem.querySelector('ul')) {
      elem.querySelector('ul').remove();
    }

    urlArr.forEach(function (obj) {
      var key = Object.keys(obj)[0];
      urls[key] = obj[key];
    });

    var partnerList = document.createElement('ul'),
      urlKeys = Object.keys(urls);
    partnerList.classList.add('partner-list', 'columns');

    for (var i = 0; i < partners.length; i++) {
      var partner = partners[i],
        listItem = document.createElement('li');

      if (urlKeys.indexOf(partner) === -1) {
        listItem.innerHTML = partner;
        partnerList.appendChild(listItem);
        continue;
      }

      var link = document.createElement('a'),
        href = urls[partner];

      link.setAttribute('href', href);
      link.setAttribute('target', '_blank');
      link.innerHTML = partner;
      listItem.appendChild(link);
      partnerList.appendChild(listItem);
    }

    elem.querySelector('.scroll-helper').appendChild(partnerList);
    elem.classList.remove('hidden');
  });
};

export const setTCPALanguage = () => {
  const partnersElem = document.getElementById('modal-partners'),
    tcpaLanguage = document.createElement('p');

  partnersElem.querySelector('.close').addEventListener('click', (e) => {
    partnersElem.classList.add('hidden');
    document.getElementById('light-box').classList.add('hidden');
  });

  document.getElementById('light-box').addEventListener('click', (e) => {
    partnersElem.classList.add('hidden');
    document.getElementById('light-box').classList.add('hidden');
  });

  tcpaLanguage.classList.add('tcpa-language');
  tcpaLanguage.innerHTML =
    'By clicking "YOU\'RE ALMOST THERE!", I provide my signature expressly consenting to receive autodialed and or artificial/prerecorded voice marketing calls and texts from Flatiron Media and/or its <a class="marketing-partners" href="">Marketing Partners</a> on the phone number provided above. I understand that I will receive these calls and texts even if I am on a federal or state do not call registry. My telephone company may impose charges on me for these contacts. I understand that I can revoke this consent at any time. I understand that my consent is not a condition of any purchase. I CONFIRM that all of my information is accurate and consent to be called and texted as provided above.';

  tcpaLanguage.querySelector('a').addEventListener('click', (e) => {
    e.preventDefault();

    getMarketingPartners();
    document.getElementById('light-box').classList.remove('hidden');
    scrollToPartners();

    setTimeout(() => {
      let documentHeight = getDocumentHeight();
      document.getElementById('light-box').style.height = documentHeight + 'px';
    }, 150);
  });

  return tcpaLanguage;
};

export const ready = (callback) => {
  if (typeof document === 'undefined') {
    throw new Error('document-ready only runs in the browser');
  }

  let state = document.readyState;

  if (['complete', 'interactive'].includes(state)) {
    return setTimeout(callback, 0);
  }

  document.addEventListener('DOMContentLoaded', function onLoad() {
    callback();
  });
};

export const getSooperPanelProps = () => {
  const wrapper = document.getElementById('panel-wrapper');

  let props = SooperPanelPropsKeys.reduce((acc, k) => {
    let value = wrapper.getAttribute(`data-${k}`) ?? false,
      key = k.replace('-', '_');

    if (value !== false) {
      value = value.replace(/\s+/g, '');
    }

    switch (key) {
      case 'log_events':
      case 'keep_pop':
        value = value === 'true';
        break;
      case 'offers':
      case 'funnel_id':
      case 'template_id':
      case 'anuranum':
      case 'anuraper':
      case 'criteo-id':
      case 'criteo-bucket-limit':
        value = parseInt(value);
        break;
    }

    return Object.assign(acc, { [key]: value });
  }, {});

  if (Object.keys(props).includes('log_events') === false) {
    props.log_events = false;
  }

  return props;
};

export class SooperBrowserStorage {
  /*
   ** is it necessary to store all cookie values in class or create get
   ** function to retrieve cookies in-case values change and aren't reflected
   ** via this classes values
   */
  constructor() {
    const arr = document.cookie.split('; ');

    Object.assign(
      this,
      arr.reduce((obj, str) => {
        let a = str.split('=');
        return Object.assign(obj, {
          [a[0]]: a[1],
        });
      }, {}),
    );
  }

  add(props) {
    let { name, value, days } = props,
      expires,
      [subdomain, domain, tld] = window.location.hostname.split('.');

    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 864e2 * 1000);
      expires = `expires=${date.toUTCString()};`;
    }

    value ??= '';
    document.cookie = `${name}=${value}; ${expires} domain=${domain}.${tld}; path=/`;
    Object.assign(this, { [name]: value });
  }

  remove(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;Max-Age=-99999999`;
  }
}

export const messenger = async (endpoint, include) => {
  let props = getSooperPanelProps();

  const Messenger = wrap(
    new Worker(new URL('../workers/Messenger.js', import.meta.url)),
  );

  if (include) {
    props = include.reduce((acc, key) => {
      if (!Object.keys(props).includes(key)) {
        return acc;
      }

      return { ...acc, [key]: props[key] };
    }, {});
  }

  return await new Messenger(endpoint, {
    ...props,
    url: `${window.location.href}${window.location.search}`,
  });
};

export const createReporter = async (status) => {
  if (!status) {
    return false;
  }

  const toInclude = [
    'source',
    'cake_id',
    'visit_id',
    'funnel_id',
    'browser_id',
  ];

  return await messenger('/api/sooper/log/save', toInclude);
};

export const tryAgainMsg = (panelFieldParent) => {
  if (panelFieldParent.querySelector('#res-msg')) {
    return;
  }

  const msg = document.createElement('p');
  msg.id = 'res-msg';
  msg.innerText = 'Sorry, something went wrong. Please try again.';
  return panelFieldParent.prepend(msg);
};

export const loader = ({ panel, status, continueBtn }) => {
  const method = status === 'hidden' ? 'add' : 'remove';
  document.getElementById('loader').classList[method]('visible');
  continueBtn.classList[method]('hidden');
  panel.classList[method]('hidden');
};

export const redirect = (uri, time) => {
  return setTimeout(() => {
    window.location = uri;
    return redirect(uri, time + 500);
  }, time);
};

export const isUserStuck = async (browser_id) => {
  try {
    const response = await axios.post(
      '/api/sooper/log/stuck',
      {
        browser_id,
      },
      {
        timeout: 1e4,
        // signal: controller.signal.timeout(1e4),
        headers: {
          'Content-Type': 'application/json',
        },
        transformRequest: [
          function (data, headers) {
            return JSON.stringify(data);
          },
        ],
        transformResponse: [
          function (data) {
            return JSON.parse(data);
          },
        ],
      },
    );
    console.log(response);
  } catch (e) {
    console.log(e);
  }
};

export const createHiddenSubmitForm = ({ endpoint, browser_id }, cb) => {
  const frm = document.createElement('form'),
    inpt = document.createElement('input'),
    inptId = document.createElement('input');

  frm.setAttribute(
    'action',
    `/api/sooper/flow/redirect${window.location.search}`,
  );
  frm.setAttribute('method', 'post');
  frm.style.display = 'none';

  inpt.setAttribute('name', 'endpoint');
  inpt.value = endpoint;

  inptId.setAttribute('name', 'browser_id');
  inptId.value = browser_id;

  frm.appendChild(inpt);
  frm.appendChild(inptId);

  document.getElementById('panel-container').appendChild(frm);
  frm.submit();

  redirect(
    `/${endpoint}${window.location.search}&browser_id=${browser_id}`,
    2e3,
  );
  cb();
};

const hasHighVisitIndex = ({ index, operator, value }) => {
  switch (operator) {
    case '>':
      return index > value;
    case '>=':
      return index >= value;
    case '<=':
      return index <= value;
    case '<':
      return index < value;
    case '=':
    case '==':
      return index === value;
    default:
      return false;
  }
};

const hasHighVisitIndexTriggers = (trigger, csv) => {
  return [null, 'false'].filter((e) => [trigger, csv].includes(e)).length;
};

export const getHighVIUserRedirect = (email_address, vi) => {
  if (email_address === 'alloffers@mdm5.com') {
    return false;
  }

  const attr = 'data-rdr',
    trigger = document.body.getAttribute(`${attr}-ht`) ?? false,
    csv = document.body.getAttribute(`${attr}-ht-value`) ?? false;

  if (hasHighVisitIndexTriggers(trigger, csv) !== 0) {
    return;
  }

  const [operator, value] = csv.split(','),
    props = {
      operator,
      index: parseInt(vi),
      value: parseInt(value),
    };

  if (hasHighVisitIndex(props) === false) {
    return;
  }

  return `/full.php?VmlzaXRJbmRleA=${vi}`;
};

const validateEmailDomain = () => {};
